import { useHistory } from 'react-router-dom';

import SITE_PATHS from '../../config/sitePaths';

const stepsInOrder = [
  { path: SITE_PATHS.LOAN, test: () => true },
  { path: SITE_PATHS.BANKING, test: (workflow) => workflow.tswebBanking },
  { path: SITE_PATHS.PAYROLL, test: (workflow) => workflow.tswebPayroll },
  { path: SITE_PATHS.UTILITY, test: (workflow) => workflow.tswebUtility },
  { path: SITE_PATHS.SOCIAL_CONNECTORS, test: (workflow) => workflow.tswebSocial },
  { path: SITE_PATHS.CHATBOT, test: (workflow) => workflow.tswebChatbot },
  { path: SITE_PATHS.THANK_YOU, test: () => true },
];

const endOfWorkflowStep = stepsInOrder.map((s) => s.path).indexOf(SITE_PATHS.THANK_YOU);

const findNextStep = (currentStep, workflow) => {
  const result = currentStep + 1;
  if (result >= stepsInOrder.length) return currentStep;
  if (stepsInOrder[result].test(workflow)) return result;
  return findNextStep(result, workflow);
};

const findPreviousStep = (currentStep, workflow) => {
  const result = currentStep - 1;
  if (result < 0) return 0;
  if (stepsInOrder[result].test(workflow)) return result;
  return findPreviousStep(result, workflow);
};

export default ({
  children, onCompleted, workflow,
}) => {
  const globalHistory = useHistory();

  let currentStep = globalHistory.location.state?.wizardCurrentStep || 0;
  if (globalHistory.action === 'POP') {
    if (globalHistory.location.pathname === stepsInOrder[0].path
       || globalHistory.location.pathname.startsWith(SITE_PATHS.INVITE_PAGE)) {
      currentStep = 0;
    } else if (globalHistory.location.pathname
      === stepsInOrder[findPreviousStep(currentStep, workflow)].path) {
      currentStep = findPreviousStep(currentStep, workflow);
    } else {
      currentStep = findNextStep(currentStep, workflow);
    }
  }

  const proceed = (nextStep, history, data) => {
    const nextPath = stepsInOrder[nextStep].path;
    currentStep = nextStep;
    if (currentStep === endOfWorkflowStep) {
      onCompleted();
    }
    history.push(nextPath, { ...data, wizardCurrentStep: currentStep });
  };

  const resume = (fromPath, history, data) => {
    const currentStepResume = stepsInOrder.map((s) => s.path).indexOf(fromPath);
    if (currentStepResume < 0) {
      // eslint-disable-next-line no-console
      console.error('Path not found in wizard', fromPath);
      return;
    }
    currentStep = currentStepResume;
    proceed(currentStep, history, data);
  };

  const onNextStep = (history, data) => {
    const nextStep = findNextStep(currentStep, workflow);
    proceed(nextStep, history, data);
  };

  return children(onNextStep, resume);
};
